import {BaseCachedService} from './Core/BaseCachedService';

class ProjectStatusService extends BaseCachedService {
    get Url() { return super.Url + "/projectStatuses"; }
    get ModelName() { return "Project Status"; }
    get PrimaryKeyProperty() { return "projectStatusId"; }
}

export const service = new ProjectStatusService();

